<template>
  <div>
    <div class="logo-title d-flex flex-row justify-content-between align-items-center">
      <div>
        <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'" @click="$router.push({name:'startPage'})">
        <div class="d-flex flex-column logo-col" style="padding-left:15px;">
          <h1 class="title">Burgers & Fries</h1>
          <h2 class="subTitle">Search or View Nearby Restaurants Below.</h2>
        </div>
      </div>
      <div>
        <button class="signIn d-flex align-items-center justify-content-around" @click="goToLogin">
          <i class="fal fa-user-circle"></i>
          <span>Account</span>
        </button>
      </div>
    </div>
    <div class="mobile-header flex-row justify-content-between" v-if="isMobile && showPage">
      <button class="mapbtn d-flex align-items-center" @click="changeState">
        <i class="far fa-list-ul" ></i>
      </button>
      
      <button class="signIn d-flex align-items-center justify-content-around">
        <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'" alt="" @click="$router.push({name:'startPage'})">
      </button>


      <button class="signIn d-flex align-items-center justify-content-around">
        <i class="fal fa-user-circle"></i>
      </button>
    </div>
  <div class="d-flex flex-row">
    <sidebar class="siteleft" v-if="showList" @change="changeState"></sidebar>
    
    <div class="mainBlock d-flex" v-if="showPage">
      <router-view></router-view>
    </div>

    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import sideBar from './sideBar.vue';
export default {
  name: 'stepOrder',
  components: { sidebar: sideBar},
  data(){
    return{
      isMobile: false,
      showList: true,
      showPage: true
    }
  },
  computed: {
    ...mapState(['info']),
  },
  watch: {
    // $route(to, from){
      // if(to.name === "review"){
      //   this.showList = true;
      //   this.showPage = true;
      // }
      // else if(this.isMobile){
      //    this.showList = false;
      //    this.showPage = true;
      // }
    //}
  },
  methods:{
    goToLogin(){
      this.$router.push({ name: 'signin'})
    },
    onResize(e) {
      let width = e.target.innerWidth;
      this.isMobile = width <= 768 ? true : false;
      if (this.isMobile) {
        if (this.showPage) {
          this.showList = false;
        } else {
          this.showList = true;
        }
      } else {
        this.showPage = true;
        this.showList = true;
      }
    },
    changeState(){
      if (this.isMobile) {
        console.log(this.$router.currentRoute)
        if (this.showPage) {
          this.showList = true;
          this.showPage = false;
        } else {
          if(this.info.restaurant.id){
            this.showList = false;
            this.showPage = true;
          }
          else{
            this.$router.push({name: "startPage"});
          }
        }
      } else {
        this.showPage = true;
        this.showList = true;
      }
    }
  },
  created(){
    let thisRef = this;
    this.onResize({ target: { innerWidth: window.screen.width } });
    window.addEventListener("resize", this.onResize);
  }
}
</script>

<style scoped>
.mainBlock{
  width: 100%;
}
.mobile-header {
  display: none;
  /* position: fixed;
  bottom:0px;
  z-index: 6; */
  box-sizing: border-box;
  height: 62px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
  /* border-radius: 30px; */
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
}
button {
  border: none;
  background: none;
}
.signIn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.signIn img{
  width: 32px;
  height: 32px;
  border-radius: 8px;
}
.signIn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.signIn span {
  margin-left: 10px;
}
.mapbtn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.mapbtn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.mapbtn span {
  margin-left: 10px;
}
.vertical-line {
  box-sizing: border-box;
  height: 36px;
  width: 1px;
  border: 1px solid #000000;
  opacity: 0.1;
}
.container-property .all-in:nth-child(2)
{
  padding-top: 33px;
}
.container-property .all-in
{
  padding-top: 10px;
}


.left-block {
  width: 20%;
}
.left-block i {
  height: 21px;
  width: 28px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
  text-align: center;
}
.line-icon
{
	box-sizing: border-box;
	height: 82px;
	width: 1px;
	border: 1px solid #000000;
	opacity: 0.1;
  margin-top: 8px;
}
.right-block {
  width: 55%;
}
.right-block h1 {
  /* height: 32px; */
  width: 155px;
  opacity: 0.8;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
  margin-bottom: 25px;
}



.right-block p {
  opacity: 0.6;
  color: #000000;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  margin: 0 ;
  width: 200px;
}
.container-property .all-in:nth-child(3) .right-block h1{
margin-bottom: 8px;
}
.modify_link {
  width: 10%;
  padding-left: 10%;
}
.modify_link a {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
}
.container-property {
  width: 100%;
  padding: 33px;
}
.signIn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.signIn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.signIn span {
  margin-left: 10px;
}
.title {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 26px;
  color: #000000;
  text-align: left;
}
.subTitle {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  /* line-height: 20px; */
  color: #000000;
  text-align: left;
}
.logo-title {
  padding: 15px 25px;
  border: 1.5px solid rgba(0, 0, 0, 0.05);
}
.logo-title div:nth-child(1){
  padding-left:5px;
}

.logo-title img {
  width: 50px;
  height: 50px;
  float: left;
  border-radius: 15px;
}
button {
   border: none;
  padding: 0;
  background: none;
  outline: none;
}
/* .order-block {
  height: 100vh;
  width: 322px;
  border-right: 1.5px solid rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  overflow-y: scroll !important;
} */
.title-property {
  text-transform: uppercase;
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
}
@media screen and (max-width: 600px) {
 
    .logo-title
    {
      width: 100%;
      display: none !important;
    }
    .mainBlock
    {
      width: 100%;
      /* display: none !important; */
    }
    .siteleft
    {
      /* display: none !important; */
    }
    .mobile-header {
    display: flex;
    position: fixed;
    z-index: 10;
    bottom: 0px;
    padding: 15px 17px;
    /* transform: translate(40%, 30%); */
  }
}
</style>




// WEBPACK FOOTER //
// src/components/stepOrder.vue